import { SITE } from "./site";

export interface FAQItem {
  question: string;
  answer: string;
}

/** Answers are intentionally limited to facts represented elsewhere on the site. */
export const FAQS: FAQItem[] = [
  { question: "Where is the studio?", answer: `CATHRYN is at ${SITE.addressLine} in ${SITE.city}. The private studio is by appointment only.` },
  { question: "What are the studio hours?", answer: "Appointments are available Tuesday through Friday from 10:00 AM to 6:00 PM and Saturday from 10:00 AM to 4:00 PM, subject to live availability." },
  { question: "How do I book an appointment?", answer: "Use the Vagaro booking calendar to choose a service and an available time. For questions before booking, call (949) 228-8554 or message @catstrubeauty on Instagram." },
  { question: "Which services are available?", answer: "The studio offers lived-in blondes, dimensional color, brunettes, coppers, extensions, and precision cutting. Each service page explains the approach and intended result." },
  { question: "What if I am not sure which service to choose?", answer: "Review the service descriptions, then call or message Cathryn before booking so the appointment can match your goals and routine." },
];
